import React from 'react';
import PropTypes from 'prop-types';

const AllHighlightedFeaturesLink = ({ onClick, displayText }) => {
	return (
		<button
			type="button"
			className="text-link text-decoration-underline text-link-muted mt-4"
			// eslint-disable-next-line react/no-unknown-property -- custom attribute used by composer-ui tab system
			ui-tabs-initial-load="false"
			onClick={onClick}
		>
			<span className="ddc-font-size-xsmall">{displayText}</span>
		</button>
	);
};

AllHighlightedFeaturesLink.propTypes = {
	onClick: PropTypes.func,
	displayText: PropTypes.string
};

export default AllHighlightedFeaturesLink;
